import React, {useState, useEffect} from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";

import {

  Select,
  MenuItem,
  makeStyles,
  Input,
  Box
} from "@material-ui/core";
import {
  Search as SearchIcon,
} from "@material-ui/icons";
import * as actions from "../../../../store/actions/actionIndex";
import CallAgentHistory from "./CallAgentHistory";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  columnIcon: {
    backgroundColor: "#0a82da",
    color: "#ffffff",
    padding: "6px",
    fontSize: "32px !important",
    borderRadius: "5px",
    cursor: "pointer",
    margin: "10px",
  
  },
});

function PreviewAgentHistory(props) {
      const classes = useStyles();
       const [actions, setActions] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [callDisp, setCallDisp] = useState("")
    const [value, setValue] = useState("Today");
 const [date, setDate] = useState()


useEffect(() => {
  props.onCallAgentHistory(props.agentId);
}, [props.agentId]);

    const handleChange = (event) =>{
       setActions(false);
    setCallDisp(event.target.value)
    props.onCallAgentHistory(props.agentId, date, 0, event.target.value)
    }

 const handleDayChange = (value) => {     
  setValue(value);

  if (value === "Yesterday") {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 1);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // month is 0-based
    const day = String(currentDate.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    setDate(formattedDate)
    props.onCallAgentHistory(props.agentId, formattedDate, 0, callDisp);
  } else {
    props.onCallAgentHistory(props.agentId, "", 0, callDisp);
    setDate("")
  }
};

  return (
    <>     
        <Box
                  p={0}
                  sx={{
                    margin: "0",
                    padding: {
                      xs: "4px",
                      sm: "15px",
                    },
                    backgroundColor: "#fff",
                  }}
                >
     <div className="abc" style={{display: "flex", justifyContent: "space-between", paddingTop: "10px"}}>
      <div style={{display: "flex", gap: "20px"}} className= "select-item"> 
                <Select value={value}
                id="demo-simple-select-standard"
                 onChange={(e) => handleDayChange(e.target.value)} input={<Input disableUnderline classes={{ input: classes.selectInput }} />} className={classes.DaySelect}>
                  <MenuItem value="Today">Today</MenuItem>
                  <MenuItem value="Yesterday">Yesterday</MenuItem>
                </Select>
      <Select
  labelId="demo-simple-select-standard-label"
  id="demo-simple-select-standard"
  value={callDisp}
  onChange={handleChange}
  input={<Input disableUnderline classes={{ input: classes.selectInput }} />}
  className={classes.DaySelect}
  displayEmpty
  label="Select Call Disposition"
  MenuProps={{
    PaperProps: {
      style: {
        maxHeight: 200, // adjust height as you need
        overflowY: "auto",
      },
    },
  }}
>
  <MenuItem value="">
    <em>Select Call Disposition</em>
  </MenuItem>
  {window.Configs.allowed_dispositions.map((item, index) => (
    <MenuItem key={index} value={item}>
      {item.toUpperCase()}
    </MenuItem>
  ))}
</Select>
</div>

<div className="" style={{display: "flex", alignItems:"center", justifyContent: "center", gap: "20px"}}>
         <div className="searched">
           <input
              className="searchText"
              id="standard-bare-name"
              variant="outlined"
              placeholder="Search by phone..."
              size="small"
              margin="normal"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />  
                                <SearchIcon />
                              </div>


                </div>
                </div>
                </Box>
              
 
   <div className="leadbucket-data">
           {!props.loading && Array.isArray(props.recentHisCalls) && props.recentHisCalls.length ? (
             <CallAgentHistory
               maxHeight="400px"
               callsData={props.recentHisCalls}
               searchQuery= {searchQuery}
             />
           ) : (
             <div style={{textAlign:"center"}}>No Calls Data to Display..</div>
           )}
         </div>
     </>
  )
}


const mapStateToProps = (state) => {
  return {
    error: state.callAgentHistory.error,
    loading: state.callAgentHistory.loading,
    agentState: state.agentData.agentState,
    agentId: state.agentData.agentId,
    campaignId: state.agentData.campaignId,
    recentHisCalls: state.callAgentHistory.recentHisCalls,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      onCallAgentHistory: (agentId,DateTime, limit, callDisp) => dispatch(actions.callAgentHistory(agentId, DateTime, limit, callDisp))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviewAgentHistory);
